// Global Style
import 'ress/ress.css'
import './global.scss'

// App
import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import Root from '~/app/views'

function init() {
  render(
    <BrowserRouter>
      <Root />
    </BrowserRouter>,
    document.getElementById('root'))
}

init()